/** Customer feature defaults plus optional unpublished staff review modes. */
(() => {
  'use strict';
  const modes = ['presentation', 'switch', 'discount', 'all'];
  const theme = window.Shopify?.theme;
  if (!['main', 'unpublished'].includes(theme?.role) || !theme.id) return;
  // Customer defaults do not depend on a URL or optional staff session state.
  window.BRCartFeatures = Object.freeze({
    enabled: (phase) =>
      window.Shopify?.theme?.role === theme.role &&
      String(window.Shopify.theme.id) === String(theme.id) &&
      ['presentation', 'switch', 'discount'].includes(phase) &&
      (window.BRCartReview ? window.BRCartReview.enabled(phase) : true),
  });
  if (theme.role !== 'unpublished') return;
  const parameter = new URL(window.location.href).searchParams.get('br_cart_review');
  const storageKey = `br-cart-review:${theme.id}`;
  let requested = parameter;
  try {
    if (parameter === null) requested = window.sessionStorage.getItem(storageKey);
    else if (modes.includes(parameter)) window.sessionStorage.setItem(storageKey, parameter);
    else window.sessionStorage.removeItem(storageKey);
  } catch {
    // Explicit links still work when optional review-mode persistence is blocked.
  }
  if (!modes.includes(requested)) return;

  const state = Object.freeze({
    mode: requested,
    // Recheck the actual role whenever a consumer asks, not only at bootstrap.
    enabled: (phase) =>
      window.Shopify?.theme?.role === 'unpublished' &&
      String(window.Shopify.theme.id) === String(theme.id) &&
      (requested === phase || requested === 'all'),
  });
  window.BRCartReview = state;

  const mount = () => {
    const toolbar = document.querySelector('[data-br-cart-review]');
    if (toolbar) {
      toolbar.hidden = false;
      for (const link of toolbar.querySelectorAll('[data-br-cart-review-mode]')) {
        const mode = link.dataset.brCartReviewMode;
        const url = new URL(window.location.href);
        url.searchParams.set('br_cart_review', mode);
        link.href = url.href;
        if (mode === requested) link.setAttribute('aria-current', 'page');
      }
    }
    document.dispatchEvent(
      new CustomEvent('br:cart-review-change', { detail: { mode: requested } })
    );
  };
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
